/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7ee81e88&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabTheme/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ee81e88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ee81e88', __exports__)) {
    api.reload('7ee81e88', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7ee81e88&ts=true", () => {
    api.rerender('7ee81e88', render)
  })

}


export default __exports__